import React, { Component } from 'react';
import MenUsuario from './menu_usuario';
import MenuClientes from './menu_clientes';

class Menu extends Component {
  render() {
    const tipo = sessionStorage.getItem('tipo');
    return (
      <div>
        {tipo === 'C' && <MenuClientes></MenuClientes>}
        {tipo !== 'C' && <MenUsuario></MenUsuario>}
      </div>);
  }
}
export default (Menu);